module.exports = __webpack_public_path__ + "static/img/1.7d8639d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/2/1/1.png
// module id = F1uV
// module chunks = 0